import { useState, useEffect } from "react";
import ConsentFragmentForm from "../ConsentFragmentForm";
import LearnMore from "./LearnMore";
import styles from "./style.module.css";
import UploadSignedPaper from "./UploadSignedPaper";
import propTypes from "prop-types";
const PaperDeclaration = ({
  setPaperForm,
  handleCollect,
  controller_code,
  customer_scope,
  language,
}) => {
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
  const [isRequiredSelected, setIsRequiredSelected] = useState(false);
  const [base64, setBase64] = useState(null);

  useEffect(() => {
    if (selectedCheckBoxes.length > 0) {
      const seenPurposes = new Set();
      const dp_records = [];

      selectedCheckBoxes.forEach((checkbox) => {
        if (!checkbox.name.startsWith("check-dpp")) return;
        const global_purpose = checkbox.name.replace("check-", "");
        if (seenPurposes.has(global_purpose)) return;
        seenPurposes.add(global_purpose);
        dp_records.push({
          global_purpose,
          collection_channel: "Truman UI",
          status: "Active",
          last_update_channel: "Truman UI",
        });
      });

      setPaperForm((prev) => ({
        ...prev,
        data_processing_authorization_records: dp_records,
      }));
    } else {
      setPaperForm((prev) => ({
        ...prev,
        data_processing_authorization_records: [],
      }));
    }
  }, [selectedCheckBoxes]);

  useEffect(() => {
    if (base64) {
      setPaperForm((prev) => ({
        ...prev,
        signature_file: base64,
      }));
    } else {
      setPaperForm((prev) => ({
        ...prev,
        signature_file: null,
      }));
    }
  }, [base64]);

  return (
    <div className={styles["consent-wrapper"]}>
      <div className={styles["declaration-container"]}>
        <h1 className={styles["declaration-title"]}>Declaration form</h1>
        <ConsentFragmentForm
          setSelectedCheckboxes={setSelectedCheckBoxes}
          setIsRequiredSelected={setIsRequiredSelected}
          controller_code={controller_code}
          customer_scope={customer_scope}
          language={language}
        />
        <UploadSignedPaper setBase64File={setBase64} />
        <button
          className={`btn-primary ${styles["submit-button"]}`}
          disabled={!isRequiredSelected || !base64}
          onClick={handleCollect}
          style={{ width: 200 }}
        >
          I AGREE
        </button>
      </div>
      <div className={styles["learn-more-container"]}>
        <LearnMore
          controller_code={controller_code}
          customer_scope={customer_scope}
          language={language}
        />
      </div>
      <div className={styles["consent-illustration"]}></div>
    </div>
  );
};

export default PaperDeclaration;

PaperDeclaration.propTypes = {
  setPaperForm: propTypes.func.isRequired,
  handleCollect: propTypes.func.isRequired,
  controller_code: propTypes.string,
  customer_scope: propTypes.string,
  language: propTypes.string,
};
